export enum ButtonType {
  Button = 'button',
  Reset = 'reset',
  Submit = 'submit'
}

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Icon = 'icon',
  Toggle = 'toggle',
  Back = 'back',
  Outline = 'outline'
}

export type RippleState = {
  key: string
  x: number
  y: number
  size: number
  pulsate?: boolean
}
